export default "__VITE_ASSET__CziPnll6__"